export default {
  common: {
    signIn: "Inloggen",
    signOut: "Uitloggen",
    signingIn: "Bezig met inloggen...",
    email: "E-mail",
    password: "Wachtwoord",
    name: "Naam",
    role: "Rol",
    save: "Opslaan",
    saving: "Opslaan...",
    cancel: "Annuleren",
    delete: "Verwijderen",
    deleting: "Verwijderen...",
    search: "Zoeken",
    edit: "Bewerken",
    back: "Terug",
    home: "Home",
    loading: "Laden...",
    sending: "Verzenden...",
    verify: "Verifiëren",
    verifying: "Verifiëren...",
    updating: "Bijwerken...",
    previous: "Vorige",
    next: "Volgende",
    user: "Gebruiker",
    coach: "Coach",
    admin: "Beheerder",
    status: "Status",
    active: "Actief",
    invited: "Uitgenodigd",
    createdAt: "Aangemaakt op",
    actions: "Acties",
    currentPassword: "Huidig wachtwoord",
    newPassword: "Nieuw wachtwoord",
    confirmPassword: "Wachtwoord bevestigen",
    confirmNewPassword: "Nieuw wachtwoord bevestigen",
    emailPlaceholder: "jij@voorbeeld.nl",
    passwordPlaceholder: "••••••••",
    namePlaceholder: "Jan Jansen",
    backToSignIn: "Terug naar inloggen",
    forgotPassword: "Wachtwoord vergeten?",
    hasAccount: "Heb je al een account?",
  },

  validation: {
    invalidEmail: "Voer een geldig e-mailadres in",
    invalidUrl: "Voer een geldige URL in",
    invalidDate: "Voer een geldige datum in",
    passwordRequired: "Wachtwoord is verplicht",
    passwordMin8: "Wachtwoord moet minimaal 8 tekens bevatten",
    passwordsDoNotMatch: "Wachtwoorden komen niet overeen",
    nameRequired: "Voer een naam in",
    currentPasswordRequired: "Huidig wachtwoord is verplicht",
    codeMustBe6Digits: "Code moet 6 cijfers bevatten",
    titleRequired: "Voer een titel in",
    categoryRequired: "Voer een categorie in",
    descriptionRequired: "Voer een beschrijving in",
    locationRequired: "Voer een locatie in",
    aboutEmployerRequired: "Beschrijf de werkgever",
  },

  auth: {
    login: {
      title: "Inloggen",
      subtitle: "Voer je gegevens in om toegang te krijgen tot je account",
      inviteAccepted: "Account geactiveerd! Je kunt nu inloggen.",
      accountDeleted: "Je account is verwijderd.",
      userSessionActive:
        "Je bent ingelogd als {{email}} op het gebruikersplatform. Log hieronder in met je beheerdersgegevens om toegang te krijgen tot dit dashboard.",
    },
    forgotPassword: {
      title: "Wachtwoord vergeten?",
      subtitle: "Voer je e-mailadres in en we sturen je een herstellink.",
      checkEmail: "Controleer je e-mail",
      checkEmailDescription:
        "Als er een account bestaat voor dat e-mailadres, hebben we een link voor het opnieuw instellen van het wachtwoord gestuurd.",
      sendResetLink: "Herstellink versturen",
      rememberPassword: "Weet je je wachtwoord weer?",
    },
    resetPassword: {
      title: "Wachtwoord opnieuw instellen",
      subtitle: "Voer hieronder je nieuwe wachtwoord in.",
      invalidLink: "Ongeldige herstellink",
      invalidLinkDescription: "Deze herstellink is ongeldig of verlopen.",
      requestNewLink: "Nieuwe link aanvragen",
      passwordUpdated: "Wachtwoord bijgewerkt",
      passwordUpdatedDescription: "Je wachtwoord is succesvol opnieuw ingesteld.",
      signInWithNewPassword: "Log in met je nieuwe wachtwoord",
      updatePassword: "Wachtwoord bijwerken",
    },
    twoFactor: {
      title: "Tweefactorauthenticatie",
      subtitle: "Verifieer je identiteit om door te gaan.",
      authenticatorApp: "Authenticator-app",
      emailCode: "E-mailcode",
      backupCode: "Herstelcode",
      totpDescription: "Open je authenticator-app en voer de 6-cijferige code in.",
      authenticationCode: "Authenticatiecode",
      otpDescription: "We sturen een eenmalige code naar je e-mailadres.",
      sendCodeToEmail: "Code naar e-mail sturen",
      backupDescription:
        "Voer een van je herstelcodes in. Elke code kan slechts één keer worden gebruikt.",
      resend: "Opnieuw versturen",
    },
    setup2fa: {
      title: "Tweefactorauthenticatie instellen",
      subtitle: "Je organisatie vereist 2FA. Stel het in om door te gaan.",
      required: "Verplicht",
      activated: "Tweefactorauthenticatie is nu actief. Doorsturen...",
    },
    acceptInvite: {
      title: "Account instellen",
      subtitle: "Welkom, {{name}}. Kies een wachtwoord om je account te activeren.",
      activateAccount: "Account activeren",
      activating: "Account activeren...",
      passwordHint: "Moet minimaal 8 tekens lang zijn",
      invalidLink: "Deze uitnodigingslink is ongeldig of verlopen",
      invalidLinkDescription:
        "De uitnodigingslink die je hebt gevolgd is niet meer geldig. Vraag een beheerder om je een nieuwe te sturen.",
      alreadyAccepted: "Uitnodiging al gebruikt",
      alreadyAcceptedDescription:
        "Deze uitnodiging is al gebruikt om een account in te stellen. Je kunt direct inloggen.",
      signInToAccount: "Inloggen op je account",
    },
  },

  profile: {
    title: "Profiel",
    account: "Account",
    changePassword: "Wachtwoord wijzigen",
    passwordUpdated: "Wachtwoord succesvol bijgewerkt.",
    twoFactor: {
      title: "Tweefactorauthenticatie",
      description: "Voeg een extra beveiligingslaag toe aan je account.",
      enabled: "Ingeschakeld",
      disabled: "Uitgeschakeld",
      setupPrompt: "Voer je wachtwoord in om 2FA in te stellen.",
      setUp: "2FA instellen",
      scanQr: "Stap 1 — Scan deze QR-code met je authenticator-app",
      cantScan: "Kun je niet scannen? Voer deze sleutel handmatig in je app in:",
      saveBackupCodes: "Stap 2 — Bewaar deze herstelcodes",
      backupCodesNote:
        "Bewaar deze op een veilige plek. Elke code kan slechts één keer worden gebruikt.",
      copyCodes: "Alle codes kopiëren",
      copiedCodes: "Gekopieerd!",
      downloadCodes: "Codes downloaden",
      savedCodesConfirm: "Ik heb mijn herstelcodes opgeslagen op een veilige plek",
      verifyStep: "Stap 3 — Verifieer met een code uit je app",
      verifyAndActivate: "Verifiëren & activeren",
      activated: "Tweefactorauthenticatie is nu actief op je account.",
      yourBackupCodes: "Je herstelcodes",
      backupCodesWarning: "Bewaar deze op een veilige plek. Je kunt ze niet opnieuw bekijken.",
      disablePrompt: "Voer je wachtwoord in om tweefactorauthenticatie uit te schakelen.",
      disable: "2FA uitschakelen",
      disabling: "Uitschakelen...",
      disabled2fa: "2FA is uitgeschakeld.",
    },
    dangerZone: {
      title: "Gevarenzone",
      description:
        "Verwijder je account en alle bijbehorende gegevens permanent. Deze actie kan niet ongedaan worden gemaakt.",
      deleteAccount: "Account verwijderen",
      deleteConfirmTitle: "Account verwijderen?",
      deleteConfirmDescription:
        "Dit verwijdert je account en alle bijbehorende gegevens permanent. Typ je e-mailadres ter bevestiging.",
      typeEmail: "Typ je e-mailadres ter bevestiging",
      confirmDelete: "Account permanent verwijderen",
    },
  },

  dashboard: {
    title: "Dashboard",
    welcome: "Welkom terug, {{name}}",
    profileLink: "Profiel",
    profileDescription: "Beheer je accountinstellingen, wachtwoord en 2FA.",
    adminLink: "Beheerpaneel",
    adminDescription: "Beheer gebruikers, bekijk het dashboard en systeeminstellingen.",
  },

  admin: {
    title: "Beheer",
    dashboard: {
      title: "Dashboard",
      subtitle: "Overzicht van je beheerpaneel",
    },
    users: {
      title: "Gebruikers",
      subtitle: "Beheer gebruikersaccounts en machtigingen",
      addUser: "Gebruiker toevoegen",
      searchPlaceholder: "Zoeken op e-mail...",
      noUsersFound: "Geen gebruikers gevonden die overeenkomen met je zoekopdracht",
      noUsersYet: "Nog geen gebruikers",
      showingRange: "{{from}} t/m {{to}} van {{total}} gebruikers",
      pageOf: "Pagina {{current}} van {{total}}",
      userCreated: "Gebruiker succesvol aangemaakt",
      userUpdated: "Gebruiker succesvol bijgewerkt",
      userDeleted: "Gebruiker succesvol verwijderd",
    },
    newUser: {
      title: "Gebruiker toevoegen",
      subtitle:
        "Er wordt een uitnodigingslink naar de gebruiker gestuurd zodat ze hun eigen wachtwoord kunnen instellen.",
      subtitleDirect: "De gebruiker kan direct inloggen met de opgegeven inloggegevens.",
      backToUsers: "Terug naar gebruikers",
      sendInvite: "Uitnodiging versturen",
      sendingInvite: "Uitnodiging versturen...",
      createUser: "Gebruiker aanmaken",
      creatingUser: "Gebruiker aanmaken...",
      passwordOptionalLabel: "Wachtwoord (optioneel)",
      passwordOptionalHint:
        "Laat leeg om een uitnodigingsmail te sturen. Vul in om inloggegevens direct in te stellen.",
      testModeWarning:
        "Het direct instellen van een wachtwoord omzeilt de uitnodigingsstroom. De gebruiker kan direct inloggen zonder e-mailverificatie. Dit is bedoeld voor testsessies en wordt in een toekomstige versie verwijderd.",
    },
    editUser: {
      title: "Gebruiker bewerken",
      subtitle: "Werk gebruikersgegevens bij",
      backToUsers: "Terug naar gebruikers",
      userId: "Gebruikers-ID",
      created: "Aangemaakt",
      pendingInvite: "Openstaande uitnodiging",
      pendingInviteDescription:
        "Deze gebruiker heeft de uitnodiging nog niet geaccepteerd. Je kunt de uitnodigingslink opnieuw versturen.",
      resendInvite: "Uitnodiging opnieuw versturen",
      resending: "Versturen...",
      inviteResent: "Uitnodiging opnieuw verstuurd",
      dangerZone: "Gevarenzone",
      deleteWarning:
        "Zodra je een gebruiker verwijdert, is er geen weg meer terug. Weet het zeker.",
      cannotDeleteSelf:
        "Je kunt je eigen account niet verwijderen. Vraag een andere beheerder om je account te verwijderen.",
      cannotChangeOwnRole: "Je kunt je eigen rol niet wijzigen.",
      deleteUser: "Gebruiker verwijderen",
      confirmDelete:
        "Weet je zeker dat je {{email}} wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
    },
    sidebar: {
      appName: "Buddy",
      dashboard: "Dashboard",
      jobSeekers: "Werkzoekenden",
      users: "Gebruikers",
      professions: "Beroepen",
      vacancies: "Vacatures",
    },
    professions: {
      title: "Beroepen",
      subtitle: "Beheer beroepsprofielen die voor matching worden gebruikt",
      addProfession: "Beroep toevoegen",
      searchPlaceholder: "Zoeken op naam of sector...",
      noProfessionsFound: "Geen beroepen gevonden die overeenkomen met je zoekopdracht",
      noProfessionsYet: "Nog geen beroepen",
      showingRange: "{{from}} t/m {{to}} van {{total}} beroepen",
      pageOf: "Pagina {{current}} van {{total}}",
      professionCreated: "Beroep succesvol aangemaakt",
      professionUpdated: "Beroep succesvol bijgewerkt",
      professionDeleted: "Beroep succesvol verwijderd",
      columns: {
        title: "Naam",
        category: "Sector",
        status: "Status",
        createdAt: "Aangemaakt op",
        actions: "Acties",
      },
      status: {
        active: "Actief",
        inactive: "Inactief",
      },
      fields: {
        title: "Naam",
        titlePlaceholder: "bijv. Software Engineer",
        category: "Sector",
        categoryPlaceholder: "bijv. IT, Zorg, Onderwijs",
        description: "Beschrijving",
        descriptionPlaceholder: "Beschrijf wat dit beroep inhoudt...",
        requirements: "Vereisten",
        requirementsHint: "Eén vereiste per regel",
        requirementsPlaceholder:
          "Bachelordiploma in Informatica\n2+ jaar ervaring\nVloeiend in Nederlands en Engels",
        commaSeparatedHint: "Scheid meerdere items met komma's",
        legalRequirements: "Wettelijke verplichting",
        legalRequirementsPlaceholder: "bijv. VOG, rijbewijs, veiligheidscertificaat",
        competencies: "Competenties",
        competenciesPlaceholder: "bijv. Energiek, teamwork, fysieke fitheid, zelfstandigheid",
        interests: "Interesse/Leuk vinden",
        interestsPlaceholder: "bijv. Werken met mensen, praktisch werk, anderen helpen",
        candidateRequirements: "Klant eisen",
        candidateRequirementsPlaceholder:
          "bijv. Prikkelarme werkplek, lang kunnen staan, lang kunnen zitten",
        additionalRequirements: "Andere eisen aan het beroep",
        additionalRequirementsPlaceholder: "bijv. Flexibele uren, ploegendienst, buiten werken",
        languageRequirement: "Taalvaardigheid gevraagd?",
        languageRequirementPlaceholder: "bijv. Nederlands B1, Nederlands B2, geen specifieke eis",
        jobOutlook: "Kansrijk of niet",
        jobOutlookPlaceholder: "bijv. Kansrijk, beperkt aantal vacatures, veel vraag",
        video: "Beroepsvideo",
        videoHint: "MP4, WebM, MOV of OGG. Maximaal 200 MB.",
        currentVideo: "Huidige video",
        replaceVideo: "Video vervangen",
        aiContext: "AI-matchingscontext (alleen beheerder)",
        aiContextHint:
          "Interne notities die de AI helpen gebruikers aan dit beroep te koppelen. Niet zichtbaar voor gebruikers.",
        aiContextPlaceholder:
          "Persoonlijkheidskenmerken, werkstijl, gerelateerde interesses, alles wat de AI helpt matches te scoren...",
        isActive: "Actief",
        isActiveHint: "Inactieve beroepen zijn verborgen voor gebruikers",
      },
    },
    newProfession: {
      title: "Beroep toevoegen",
      subtitle: "Maak een nieuw beroepsprofiel aan",
      backToProfessions: "Terug naar beroepen",
      submit: "Beroep aanmaken",
      submitting: "Aanmaken...",
    },
    editProfession: {
      title: "Beroep bewerken",
      subtitle: "Werk de gegevens van het beroep bij",
      backToProfessions: "Terug naar beroepen",
      created: "Aangemaakt",
      dangerZone: "Gevarenzone",
      deleteWarning:
        "Het verwijderen van een beroep verwijdert ook de video en ontkoppelt alle matches en beslissingen van gebruikers. Dit kan niet ongedaan worden gemaakt.",
      deleteProfession: "Beroep verwijderen",
      confirmDelete:
        'Weet je zeker dat je "{{title}}" wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    },
    vacancies: {
      title: "Vacatures",
      subtitle: "Beheer vacatures die aan gebruikers worden getoond",
      addVacancy: "Vacature toevoegen",
      searchPlaceholder: "Zoeken op titel, categorie of locatie...",
      noVacanciesFound: "Geen vacatures gevonden die overeenkomen met je zoekopdracht",
      noVacanciesYet: "Nog geen vacatures",
      showingRange: "{{from}} t/m {{to}} van {{total}} vacatures",
      pageOf: "Pagina {{current}} van {{total}}",
      vacancyCreated: "Vacature succesvol aangemaakt",
      vacancyUpdated: "Vacature succesvol bijgewerkt",
      vacancyDeleted: "Vacature succesvol verwijderd",
      columns: {
        title: "Titel",
        category: "Categorie",
        location: "Locatie",
        status: "Status",
        createdAt: "Aangemaakt op",
        actions: "Acties",
      },
      status: {
        active: "Actief",
        inactive: "Inactief",
      },
      sections: {
        jobDetails: "Functiegegevens",
        companyDetails: "Bedrijfsgegevens",
        jobRequirements: "Functie-eisen",
        offer: "Aanbod",
        applicationProcedure: "Sollicitatieprocedure",
        admin: "Beheer",
      },
      fields: {
        title: "Functienaam",
        titlePlaceholder: "bijv. Junior Software Developer",
        category: "Categorie",
        categoryPlaceholder: "bijv. ICT, Zorg, Onderwijs",
        location: "Plaats van het werk",
        locationPlaceholder: "bijv. Amsterdam",
        description: "Inhoud van het werk",
        descriptionPlaceholder:
          "Beschrijf de functie, verantwoordelijkheden en wat de kandidaat gaat doen...",
        employer: "Werkgever",
        employerPlaceholder: "bijv. Brthrs B.V.",
        employerAddress: "Adres",
        employerAddressPlaceholder: "Straat, nummer, postcode, plaats",
        employerPhone: "Telefoonnummer",
        employerPhonePlaceholder: "bijv. +31 20 123 4567",
        employerWebsite: "Website",
        employerWebsitePlaceholder: "https://voorbeeld.nl",
        aboutEmployer: "Bedrijfsomschrijving",
        aboutEmployerPlaceholder:
          "Vertel kandidaten over het bedrijf: wie ze zijn, wat ze doen en waarom het een fijne werkplek is...",
        education: "Opleiding",
        educationPlaceholder: "bijv. HBO Informatica of vergelijkbaar",
        competencies: "Competenties",
        competenciesPlaceholder: "communicatie, probleemoplossend, samenwerken",
        commaSeparatedHint: "Komma-gescheiden, bijv. communicatie, probleemoplossend",
        driversLicense: "Rijbewijs",
        driversLicensePlaceholder: "bijv. B",
        requirements: "Overige eisen",
        requirementsHint: "Eén vereiste per regel. Deze worden als chips getoond.",
        requirementsPlaceholder:
          "HBO Informatica of vergelijkbaar\n2+ jaar ervaring\nVloeiend in Nederlands en Engels",
        salary: "Salaris",
        salaryPlaceholder: "bijv. €2500 per maand of €18 per uur",
        salaryHint: "Kan een maand- of uursalaris zijn",
        hoursPerWeek: "Aantal uur per week",
        hoursPerWeekPlaceholder: "bijv. 32-40",
        hoursPerWeekHint: "Kan een vast aantal of een bereik zijn",
        contractType: "Arbeidsovereenkomst",
        contractTypePlaceholder: "bijv. Vast, Tijdelijk, Parttime",
        otherOffer: "Overig aanbod",
        otherOfferPlaceholder: "Extra arbeidsvoorwaarden, bonussen, opleidingsbudget...",
        requestedDocuments: "Gevraagde documenten",
        requestedDocumentsPlaceholder: "CV\nMotivatiebrief\nReferenties",
        requestedDocumentsHint: "Eén document per regel.",
        applicationContactInfo: "Contact bij vragen",
        applicationContactInfoPlaceholder: "Hoe kandidaten contact kunnen opnemen met vragen",
        applicationContactPerson: "Contactpersoon sollicitatie",
        applicationContactPersonPlaceholder: "Naam van de contactpersoon",
        applicationWebsite: "Website sollicitatie",
        applicationWebsitePlaceholder: "https://voorbeeld.nl/solliciteren",
        applicationAddress: "Adres sollicitatie",
        applicationAddressPlaceholder: "Postadres voor sollicitaties",
        applicationEmail: "Emailadres sollicitatie",
        applicationEmailPlaceholder: "solliciteren@voorbeeld.nl",
        applicationDeadline: "Reactie voor",
        aiContext: "AI-matchingscontext (alleen beheerder)",
        aiContextHint:
          "Interne notities die de AI helpen gebruikers aan deze vacature te koppelen. Niet zichtbaar voor gebruikers.",
        aiContextPlaceholder:
          "Persoonlijkheidsfit, werkstijl, ideaal kandidaatprofiel, alles wat de AI helpt matches te scoren...",
        isActive: "Actief",
        isActiveHint: "Inactieve vacatures zijn verborgen voor gebruikers",
      },
    },
    newVacancy: {
      title: "Vacature toevoegen",
      subtitle: "Maak een nieuwe vacature aan",
      backToVacancies: "Terug naar vacatures",
      submit: "Vacature aanmaken",
      submitting: "Aanmaken...",
    },
    editVacancy: {
      title: "Vacature bewerken",
      subtitle: "Werk de gegevens van de vacature bij",
      backToVacancies: "Terug naar vacatures",
      created: "Aangemaakt",
      dangerZone: "Gevarenzone",
      deleteWarning:
        "Het verwijderen van een vacature ontkoppelt alle matches en beslissingen van gebruikers. Dit kan niet ongedaan worden gemaakt.",
      deleteVacancy: "Vacature verwijderen",
      confirmDelete:
        'Weet je zeker dat je "{{title}}" wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    },
  },

  coach: {
    jobSeekers: {
      title: "Werkzoekenden",
      subtitle: "Bekijk gebruikersprofielen voor coaching en analyse",
      searchPlaceholder: "Zoeken op naam of e-mail...",
      noJobSeekersFound: "Geen werkzoekenden gevonden die overeenkomen met je zoekopdracht",
      noJobSeekersYet: "Nog geen werkzoekenden",
      showingRange: "{{from}} t/m {{to}} van {{total}} werkzoekenden",
      pageOf: "Pagina {{current}} van {{total}}",
      notProvided: "Niet ingevuld",
      onboardingComplete: "Onboarding voltooid",
      onboardingIncomplete: "Onboarding niet voltooid",
      columns: {
        residence: "Woonplaats",
        onboarding: "Onboarding",
      },
    },
    jobSeekerDetails: {
      title: "Details werkzoekende",
      backToJobSeekers: "Terug naar werkzoekenden",
      lastActivity: "Laatste activiteit",
      notAvailable: "Niet beschikbaar",
      answered: "Beantwoord",
      notAnswered: "Nog niet beantwoord",
      yes: "Ja",
      no: "Nee",
      maybe: "Misschien",
      completed: "Voltooid",
      currentStep: "Stap {{step}}",
      answeredOfTotal: "{{answered}} / {{total}} beantwoord",
      modulesCompleted: "{{completed}} / {{total}} modules voltooid",
      decidedOfTotal: "{{decided}} / {{total}} beslist",
      likedCount: "{{count}} leuk gevonden",
      documentsAvailable: "Beschikbare documenten",
      fileSizeKb: "{{size}} KB",
      fileSizeMb: "{{size}} MB",
      riasecScore: "Score {{score}}",
      matchScore: "{{score}}% match",
      decidedAt: "Beslist op {{date}}",
      reason: "Reden",
      aiMatchExplanation: "AI-matchuitleg",
      noDecisionYet: "De gebruiker heeft nog niet beslist over deze match.",
      pendingDecision: "Openstaand",
      liked: "Leuk gevonden",
      notLiked: "Niet leuk gevonden",
      elaboration: "Toelichting",
      aiFollowUp: "AI-vervolgvraag",
      summaryCards: {
        questionnaires: "Vragenlijsten",
        professions: "Beroepen",
        vacancies: "Vacatures",
        documents: "Documenten",
      },
      profileSummary: {
        title: "AI-samenvatting profiel",
        description: "Gegenereerd op basis van de antwoorden in de vragenlijst.",
        generatedAt: "Gegenereerd op {{date}}",
        empty: "Er is nog geen profielsamenvatting gegenereerd.",
      },
      questionnaires: {
        title: "Vragenlijsten",
        description: "Alle vragen worden getoond, ook vragen die nog niet beantwoord zijn.",
        riasecTitle: "RIASEC-antwoorden",
        riasecDescription: "Interessescores die worden gebruikt voor het matchingsprofiel.",
        noRiasec: "Er zijn geen RIASEC-vragen beschikbaar.",
      },
      experiences: {
        title: "Ervaringen",
        description:
          "Gestructureerde opleidings-, werk-, cursus-, stage- en vrijwilligerservaringen uit de vragenlijst.",
        empty: "Er zijn nog geen ervaringen toegevoegd.",
        addedCount: "{{count}} ervaringen toegevoegd",
        organization: "Organisatie",
        institution: "Instelling",
        fieldOfStudy: "Studierichting",
        tasks: "Taken",
        hasDiploma: "Diploma behaald",
        hasCertificate: "Certificaat behaald",
        wantsRelatedWork: "Wil gerelateerd werk",
        wantsRelatedWorkExplanation: "Toelichting",
        enjoyedAspects: "Leuke aspecten",
        dislikedAspects: "Minder leuke aspecten",
        reasonStopped: "Reden gestopt",
        aiFollowUpEnjoyed: "AI-vervolgvraag over leuke aspecten",
        aiFollowUpDisliked: "AI-vervolgvraag over minder leuke aspecten",
        period: "{{start}} - {{end}}",
        periodCurrent: "{{start}} - heden",
      },
      experienceType: {
        education: "Opleiding",
        course: "Cursus",
        profession: "Werkervaring",
        internship: "Stage",
        volunteer: "Vrijwilligerswerk",
      },
      professions: {
        title: "Beroepen",
        description: "Getoonde matches die de gebruiker heeft gezien. Matchingstatus: {{status}}.",
        summaryTodo:
          "TODO: Voeg een AI-samenvatting toe die de gekozen beroepen uitlegt zodra deze wordt gegenereerd.",
        empty: "Er zijn nog geen getoonde beroepmatches beschikbaar.",
      },
      vacancies: {
        title: "Vacatures",
        description:
          "Getoonde vacaturematches die de gebruiker heeft gezien. Matchingstatus: {{status}}.",
        summaryTodo:
          "TODO: Voeg een AI-samenvatting toe die de vacaturematches uitlegt zodra deze wordt gegenereerd.",
        empty: "Er zijn nog geen getoonde vacaturematches beschikbaar.",
      },
      documents: {
        title: "Documenten",
        description: "Geüploade en gegenereerde documenten voor deze werkzoekende.",
        uploadedCvs: "Geüploade cv's",
        generatedDocuments: "Gegenereerde documenten",
        noUploadedCvs: "Nog geen geüploade cv's.",
        noGeneratedDocuments: "Nog geen gegenereerde cv's of motivatiebrieven.",
        fileAvailable: "Gegenereerd bestand beschikbaar",
        fileNotAvailable: "Gegenereerd bestand nog niet beschikbaar",
        download: "Downloaden",
        forVacancy: "{{date}} voor {{vacancy}}",
      },
      processingStatus: {
        notStarted: "Niet gestart",
        pending: "Openstaand",
        processing: "Wordt verwerkt",
        completed: "Voltooid",
        failed: "Mislukt",
      },
      documentType: {
        resume: "Gegenereerd cv",
        motivationalLetter: "Motivatiebrief",
      },
      klantbeeld: {
        title: "Klantbeeld",
        description: "Overzicht van de werkzoekende op basis van de vragenlijst.",
        columns: {
          onderdelen: "Onderdelen Klantbeeld",
          onderwerpen: "Onderwerpen Klantbeeld",
          items: "Items Klantbeeld",
        },
        empty: "—",
        phrases: {
          strong: "Sterke: {{value}}",
          weaker: "Minder sterke: {{value}}",
          describedAs: "Mensen omschrijven mij als: {{value}}",
          energy: "Ik krijg energie van: {{value}}",
          wantUnderstood: "Ik wil dat anderen van mij begrijpen: {{value}}",
          dropOut: "Ik haak soms af of stop door: {{value}}",
          homeCalm: "Rustige thuissituatie",
          homeNotCalm: "Niet-rustige thuissituatie",
          homeArrange: "Als ik morgen zou beginnen, moet ik nog regelen: {{value}}",
          tasksLiked: "Ik vind het leuk om te doen: {{value}}",
          tasksDisliked: "Ik vind niet zo leuk om te doen: {{value}}",
          eduLiked: "Positief: {{value}}",
          eduDisliked: "Minder positief: {{value}}",
          toelichting: "Toelichting: {{value}}",
        },
        loadLabels: {
          staand: "Ik kan zonder problemen staand werk doen",
          zittend: "Ik kan zonder problemen zittend werk doen",
          lopend: "Ik kan zonder problemen lopend werk doen",
          tillen: "Kan tillen",
          gezondheid: "Lichamelijke gezondheid",
        },
        work: {
          roleFull: "Werkte als {{jobTitle}} bij {{organization}}.",
          roleJob: "Werkte als {{jobTitle}}.",
          roleCompany: "Werkte bij {{organization}}.",
          period: "Periode: van {{start}} tot {{end}}.",
          periodCurrent: "Periode: sinds {{start}} (huidige functie).",
          duration: "Duur: {{value}}.",
          tasks: "Taken: {{tasks}}.",
          reason: "Reden van stoppen: {{reason}}.",
          liked: "Wat leuk was: {{liked}}.",
          disliked: "Wat minder leuk was: {{disliked}}.",
          detail: "Toelichting: {{value}}.",
          years_one: "{{count}} jaar",
          years_other: "{{count}} jaar",
          months_one: "{{count}} maand",
          months_other: "{{count}} maanden",
        },
        parts: {
          wieBenIk: "Wie ben ik?",
          watWilIk: "Wat wil ik?",
          watKanIk: "Wat kan ik?",
          watHebIkGedaan: "Wat heb ik gedaan",
        },
        subjects: {
          algemeneInformatie: "Algemene informatie",
          persoonlijkheid: "Persoonlijkheid",
          socialeContext: "Sociale context",
          gewenstWerk: "Gewenst werk",
          werkwensen: "Werkwensen",
          opleiding: "Opleiding",
          hobbys: "Hobby's",
          vervoer: "Vervoer",
          belastbaarheid: "Belastbaarheid",
          werkervaring: "Werkervaring",
        },
        items: {
          voorEnAchternaam: "Voor- en achternaam",
          woonplaats: "Woonplaats",
          sterkeEigenschappen: "sterke eigenschappen",
          minderSterkeEigenschappen: "minder sterke eigenschappen",
          overigeKaraktereigenschappen: "overige karaktereigenschappen",
          competenties: "competenties",
          gezinssituatie: "gezinssituatie/woonsituatie",
          beroep: "Beroep",
          taken: "Taken",
          werkomgeving: "Werkomgeving",
          werktijden: "Werktijden",
          niveau: "niveau",
          richting: "richting",
          opleidingAfgerond: "opleiding afgerond/geslaagd?",
          watVondJeErvan: "wat vond je ervan?",
          cursussenTraining: "cursussen/training",
          auto: "auto",
          ov: "OV",
          scooter: "scooter",
          fiets: "fiets",
          fysiek: "Fysiek",
          mentaal: "Mentaal",
          bedrijven: "bedrijven",
          vaardigheden: "Vaardigheden",
        },
      },
    },
  },

  errors: {
    somethingWentWrong: "Er is iets misgegaan",
    somethingWentWrongRetry: "Er is iets misgegaan. Probeer het opnieuw.",
    unexpectedError: "Er is een onverwachte fout opgetreden. Probeer het later opnieuw.",
    accessDenied: "Toegang geweigerd",
    accessDeniedDescription: "Je hebt geen toestemming om deze pagina te bekijken.",
    pageNotFound: "Pagina niet gevonden",
    pageNotFoundDescription: "De pagina die je zoekt bestaat niet of is verplaatst.",
    tryAgain: "Opnieuw proberen",
    errorStatus: "Fout {{status}}",
    failedToUpdatePassword: "Wachtwoord bijwerken mislukt.",
    failedToEnable2fa: "2FA inschakelen mislukt.",
    invalidCodeRetry: "Ongeldige code. Probeer het opnieuw.",
    failedToSendCode: "Code versturen mislukt. Probeer het opnieuw.",
    invalidBackupCode: "Ongeldige herstelcode. Probeer het opnieuw.",
    failedToDisable2fa: "2FA uitschakelen mislukt.",
    failedToDeleteAccount: "Account verwijderen mislukt.",
    invalidInviteLink: "Ongeldige uitnodigingslink",
    inviteNoLongerValid: "Deze uitnodiging is niet meer geldig",
    cannotDeleteOwnAccount: "Je kunt je eigen account niet verwijderen",
    userNotFound: "Gebruiker niet gevonden",
    emailAlreadyExists: "Er bestaat al een gebruiker met dit e-mailadres",
    professionNotFound: "Beroep niet gevonden",
    vacancyNotFound: "Vacature niet gevonden",
    directPasswordNotEnabled:
      "Direct aanmaken van een wachtwoord is in deze omgeving niet ingeschakeld.",
    tooManyRequests: "Te veel verzoeken. Probeer het later opnieuw.",
    invalidVideoType: "Ongeldig videoformaat. Gebruik MP4, WebM, MOV of OGG.",
    videoTooLarge: "Videobestand is te groot. Maximaal 200 MB.",
    fileEmpty: "Het geselecteerde bestand is leeg.",
    fileTooLarge: "Videobestand is te groot. Maximaal 200 MB.",
    invalidFileType: "Ongeldig videoformaat. Gebruik MP4, WebM, MOV of OGG.",
    fileContentMismatch:
      "De inhoud van het bestand komt niet overeen met de naam. Upload een echt videobestand.",
  },
} as const;
